import { html, css } from 'lit-element';
import { FormElement } from './form-element-base';
import set from 'lodash/set';
import '@trumedianetworks/tmn-core-components/src/tmn-input';
import '@trumedianetworks/tmn-core-components/src/tmn-grid';
import '@trumedianetworks/tmn-core-components/src/tmn-checkbox';
import '@trumedianetworks/tmn-core-components/src/tmn-button';
import '@trumedianetworks/tmn-core-components/src/tmn-icon';
import '@trumedianetworks/tmn-core-components/src/tmn-select';
import '@trumedianetworks/tmn-core-components/src/tmn-form-group';

class FormElementDomain extends FormElement {
    constructor() {
        super();
    }

    static get styles() {
        return [
            ...super.styles,
            css`
                :host {
                    display: flex;
                    flex-flow: column;
                }
                tmn-select {
                    max-width: 200px;
                }
                tmn-input {
                    max-width: 300px;
                }
                tmn-form-group tmn-icon {
                    margin-left: 0px;
                    margin-right: 6px;
                }
                tmn-icon-button[name='domain-check'] {
                    padding-bottom: 5px;
                }
                .dns-check-container,
                .dns-update-container {
                    margin: 6px 0;
                    display: flex;
                    align-items: center;
                }
                .dns-update-container tmn-button {
                    margin-left: 12px;
                }
                .dns-update-container tmn-select {
                    min-width: 155px;
                }
                .dns-check-container span {
                    margin-left: 12px;
                    font-weight: 600;
                    color: var(--app-success-color);
                }
                /* tmn-form-group label {
                    font-weight: 600;
                } */
            `,
        ];
    }

    static get properties() {
        return {
            cname: {
                type: String,
            },
            // site guid
            guid: {
                type: String,
            },
        };
    }

    render() {
        const {
            itemTemplate,
            hasPassedValidationCheck,
            value,
            isDirty,
            isReadOnly,
            validationError,
            guid,
        } = this;

        const { isOptional } = itemTemplate;
        const required = !isOptional;
        const displayLabel = this.getDisplayLabel();
        if (this.isViewMode() || isReadOnly) {
            return html`<tmn-form-group>
                <label>${displayLabel}:</label>
                <span>${value}</span>
            </tmn-form-group>`;
        }
        return html`<tmn-input
                .error=${validationError}
                label=${displayLabel}
                ?disabled=${isReadOnly}
                .required=${required}
                .value=${value}
                @tmn-input-changed=${this.handleInputChanged}>
            </tmn-input>
            ${
                isDirty
                    ? html`<div class="dns-check-container">
                          <tmn-button name="domain-check" @click=${this.checkDomain}>
                              <tmn-icon
                                  slot="startIcon"
                                  icon="dns"
                                  iconVariant="outlined"></tmn-icon>
                              Check Domain
                          </tmn-button>
                          ${hasPassedValidationCheck
                              ? html`<span>Passed validation checks</span>`
                              : null}
                      </div>`
                    : null
            }
                ${
                    guid
                        ? html`<div class="dns-update-container">
                              ${this.renderCNAMEOptions()}
                              <tmn-button @click=${this.updateDNSRecord} .disabled=${!this.cname}>
                                  <tmn-icon
                                      slot="startIcon"
                                      icon="cloud_sync"
                                      iconVariant="outlined"></tmn-icon>
                                  Update DNS
                              </tmn-button>
                          </div>`
                        : null
                }
            </div>`;
    }

    renderCNAMEOptions() {
        const { itemTemplate } = this;
        const { CNAMEOptions } = itemTemplate;
        if (this.isViewMode()) {
            return null;
        }
        return html`<tmn-select
            .multiple=${false}
            .noSearch=${true}
            .placeholder=${'DNS Environment'}
            .data=${CNAMEOptions}
            .forceDefault=${true}
            @tmn-selections-changed=${this.handleSelectChanged}></tmn-select>`;
    }

    handleInputChanged({ detail }) {
        const { value } = detail;
        const { path } = this;
        this.actions.setStagedEditByPath(path, value);
    }

    handleSelectChanged(e) {
        const { detail } = e;
        const { selections } = detail;
        this.cname = selections[0].name;
    }

    checkDomain() {
        const { value, path } = this;
        if (this.isViewMode()) {
            return;
        }
        const partialSiteData = set({}, path, value);
        this.actions.validateDomain(partialSiteData);
    }

    updateDNSRecord() {
        const { value, cname, path } = this;
        if (this.isViewMode()) {
            return;
        }
        const dnsData = { domain: value, cname };
        this.actions.updateDNS(dnsData);
    }
}

customElements.define('form-element-domain', FormElementDomain);
